import { Injectable } from '@angular/core';
import { StorageMap } from '@ngx-pwa/local-storage';
import { Subscription, interval } from 'rxjs';
import { UserRequestsService } from '../user/user-requests.service';
import { Router } from '@angular/router';
import { GlobalService } from '../global/global.service';
import { Auth } from 'aws-amplify';
import { DialogModalSurveyService } from '../dialog-modal-survey/dialog-modal-survey.service';

@Injectable({
  providedIn: 'root'
})
export class SessionVerificationService {
  private sessionCheckInterval$: Subscription;
  private isVerificationStarted = false;

  constructor(private storageMap: StorageMap,
    private userRequests: UserRequestsService,
    private router: Router,
    public globalService: GlobalService,
    private modalSurveyService: DialogModalSurveyService,) { }

    startSessionVerification(intervalMs: number = 20000) {
      if (!this.isVerificationStarted) {
        this.isVerificationStarted = true;
        this.sessionCheckInterval$ = interval(intervalMs).subscribe(async () => {
          try {
            const currentUser = await Auth.currentAuthenticatedUser({ bypassCache: true });
            const currentSessionID = currentUser.attributes['custom:sessionID'];
            const localSessionID = localStorage.getItem('sessionID');
            
            if (currentSessionID && localSessionID && currentSessionID !== localSessionID) {
              this.handleSessionChange();
            }
          } catch (error) {
            console.error('Error verificando el SessionID. Error:', error);
          }
        });
      }
      
    }

  private handleSessionChange() {
    this.storageMap.clear().subscribe(() => {
      this.userRequests.resetCognito().subscribe(() => {
        this.userRequests.resetCognito();
        this.userRequests.resetUserData();
        localStorage.clear(); 
        this.modalSurveyService.setModalShown(false);
        localStorage.setItem('isModalShown', JSON.stringify(false));
        this.stopSessionVerification();
        this.router.navigate(['/login'], { queryParams: { sessionEnded: 'true' } }).then(() => this.globalService.hideLoading());
      });
    });
  }

  stopSessionVerification() {
    if (this.sessionCheckInterval$) {
      this.sessionCheckInterval$.unsubscribe();
      this.isVerificationStarted = false;
    }
  }
}
